module.exports = __webpack_public_path__ + "assets/images/boundaries/ge-icon.svg?v=8fc97d79";